// ============================================================================
// FNE-BRIDGE Frontend - Composant Alert + Snackbar global
// ============================================================================

import React from 'react';
import { Alert, AlertTitle, Snackbar, Collapse, type AlertProps } from '@mui/material';
import { useNotification } from '../../hooks/useNotification';

// --- Alert inline ---
export interface AppAlertProps extends AlertProps {
  title?: string;
  show?: boolean;
  closable?: boolean;
  onClose?: () => void;
}

export const AppAlert: React.FC<AppAlertProps> = ({
  title,
  show = true,
  closable = false,
  onClose,
  children,
  ...props
}) => {
  return (
    <Collapse in={show}>
      <Alert
        {...props}
        onClose={closable ? onClose : undefined}
        sx={{ mb: 2, borderRadius: 2, ...props.sx }}
      >
        {title && <AlertTitle sx={{ fontWeight: 600 }}>{title}</AlertTitle>}
        {children}
      </Alert>
    </Collapse>
  );
};

// --- Snackbar global (à placer dans App.tsx) ---
export const GlobalSnackbar: React.FC = () => {
  const { open, message, severity, duration, close } = useNotification();

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={close}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        onClose={close}
        severity={severity}
        variant="filled"
        elevation={6}
        sx={{ borderRadius: 2, minWidth: 300 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
